export const QA_PHONE_CODE = 'QA'
